module.exports = __webpack_public_path__ + "static/media/removebg-white.57336fbe.svg";